import { render, staticRenderFns } from "./manageCart.vue?vue&type=template&id=125dd956&scoped=true"
import script from "./manageCart.vue?vue&type=script&lang=js"
export * from "./manageCart.vue?vue&type=script&lang=js"
import style0 from "./manageCart.vue?vue&type=style&index=0&id=125dd956&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125dd956",
  null
  
)

export default component.exports